<template>
    <div>
        <!--Invoice Detail Modal-->
        <div v-if="invoiceDetail" class="modal fade" id="invoiceDetailModal" tabindex="-1" role="dialog" aria-labelledby="invoiceDetailModalTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Invoice Detail</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <h5 class="font-weight-light text-white bg-primary mx-3 p-2">Invoice Information</h5>
                        <div class="row mx-3 text-sm">
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter">
                                Id
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 text-sm">
                                {{ (invoiceDetail)? invoiceDetail.Id:'' }}
                            </div>
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-l-0">
                                Due Date
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-l-0">
                                {{ (invoiceDetail)? formatQuickBookDate(invoiceDetail.DueDate):'' }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                Doc Number
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                {{ (invoiceDetail)? invoiceDetail.DocNumber:'' }}
                            </div>
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                Created Date
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                {{ (invoiceDetail)? formatQuickBookDateTime(invoiceDetail.MetaData.CreateTime):'' }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                Last Updated Date
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                {{ (invoiceDetail)? formatQuickBookDateTime(invoiceDetail.MetaData.LastUpdatedTime):'' }}
                            </div>
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                Balance
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                {{ (invoiceDetail)? '$'+invoiceDetail.Balance:'' }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                Total Amount
                            </div>
                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                {{ (invoiceDetail)? '$'+invoiceDetail.TotalAmt:'' }}
                            </div>
                        </div>

                        <h5 v-if="invoiceDetail.Line.length > 0" class="font-weight-light text-white bg-primary mx-3 p-2 mt-4">Line Item Information</h5>
                        <div class="row mx-3 text-sm">
                            <div class="col-2 border-1 p-2 bg-grey-lighter">
                                Item
                            </div>
                            <div class="col-4 border-1 border-l-0 p-2 bg-grey-lighter">
                                Description
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 bg-grey-lighter">
                                Unit Price
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 bg-grey-lighter">
                                Quantity
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 bg-grey-lighter">
                                Amount
                            </div>
                        </div>
                        <div class="row mx-3 text-sm" v-for="(line, index) in invoiceDetail.Line" v-if="(invoiceDetail.Line.length-2) >= index">
                            <div class="col-2 border-1 p-2 border-t-0">
                                {{ line.SalesItemLineDetail.ItemRef.name }}
                            </div>
                            <div class="col-4 border-1 border-l-0 p-2 border-t-0">
                                {{ line.Description }}
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                ${{ line.SalesItemLineDetail.UnitPrice }}
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                {{ line.SalesItemLineDetail.Qty }}
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                ${{ line.Amount }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-10 border-1 p-2 border-t-0 text-right bg-grey-lighter">
                                Sub Total
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                ${{ invoiceDetail.Line[invoiceDetail.Line.length-1].Amount }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-10 border-1 p-2 border-t-0 text-right bg-grey-lighter">
                                Tax Amount
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                ${{ invoiceDetail.TxnTaxDetail.TotalTax }}
                            </div>
                        </div>
                        <div class="row mx-3 text-sm">
                            <div class="col-10 border-1 p-2 border-t-0 text-right bg-grey-lighter">
                                Total Amount
                            </div>
                            <div class="col-2 border-1 border-l-0 p-2 border-t-0">
                                {{ (invoiceDetail)? '$'+invoiceDetail.TotalAmt:'' }}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <!--Select Options for Quick Book Modal-->
        <div class="modal" id="optionsForQuickBookModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title">Select option for QuickBooks</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="selectOptionsForQuickBookClose()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-group">
                                <button type="button" class="btn btn-primary" @click="selectFromExistingQBCustomersModal()">Select from QuickBooks existing customers</button>
                            </div>
                            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 form-group">
                                <button type="button" class="btn btn-primary" @click="createCustomerToQB()">Create new customer on QuickBooks</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--Select from existing QuickBook Customer-->
        <div class="modal" id="selectFromExistingQBCustomerModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title">Select QuickBooks existing customer</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="selectFromExistingQBCustomersModalClose()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <span class="text-primary mb-3 cursor-pointer d-inline-block" @click="selectFromExistingQBCustomersModalClose()">
                        <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
                        </span>
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">QuickBooks customers</label>
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="quickBookCustomers"
                                    v-model="selectedQuickBookCustomer"
                                    label="DisplayName"
                                    placeholder="Search and Select..."
                                    :multiple="false"
                                    track-by="id"
                                    :show-labels="false"
                                    :taggable="true"
                                    :close-on-select="true"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="mt-2" v-if="selectedQuickBookCustomer">
                            <h5 class="font-weight-light text-white bg-primary mx-3 p-2">Customer Information</h5>
                            <div class="row mx-3 text-sm">
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter">
                                    Display Name
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 text-sm">
                                    {{ selectedQuickBookCustomer.DisplayName }}
                                </div>
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-l-0">
                                    Company Name
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-l-0">
                                    {{ selectedQuickBookCustomer.CompanyName }}
                                </div>
                            </div>
                            <div class="row mx-3 text-sm">
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                    QB Id
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                    {{ selectedQuickBookCustomer.Id }}
                                </div>
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                    Created Date
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                    {{ (selectedQuickBookCustomer.MetaData)? formatQuickBookDateTime(selectedQuickBookCustomer.MetaData.CreateTime):'' }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="selectQBCustomer()">Select Customer</button>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="d-flex flex-row text-teal hover:text-teal-dark font-base text-sm mb-4 justify-content-between syncFoundationDiv">
                <div @click="goBack" class="d-flex justify-content-center cursor-pointer">
                    <div>
                        <span class="material-icons">chevron_left</span>
                    </div>
                    <div>
                        <span>Back</span>
                    </div>
                </div>
                <div class="d-flex">
                    <button @click="pushContactToFoundation" v-if="canErpCreate && contactPushToFoundation && company.is_residential && !contact.foundation_customer_no"
                            class="py-2 px-2 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                        <i v-if="pushToFoundationLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i> Push To Foundation
                    </button>
                    <span class="text-green-foundation" v-if="canErpSync && contactPushToFoundation && company.is_residential && contact.foundation_customer_no">Contact synced with Foundation</span>
                    <button @click="syncFromFoundationValidation" v-if="foundationPullDataAccess && company.is_residential"
                            class="py-2 px-2 ml-2 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                        <i v-if="syncFromFoundationLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i> Sync From Foundation
                    </button>

                    <vista-contact ref="ContactVistaComponent" v-if="vistaAccess && company.is_residential" :company="company" :contact="contact" :user="user" :team="team" :erpConnections="erpConnections" :can-erp-create="canErpCreate" :can-erp-update="canErpUpdate" :can-erp-sync="canErpSync"></vista-contact>
					<spectrum-contact  ref="ContactSpectrumComponent" v-if="spectrumAccess && spectrumContactMapping && company.is_residential" :company="company" :contact="contact" :user="user" :team="team" :contactMapping="spectrumContactMapping" :spectrumCustomerCodeCustomFieldId="spectrumCustomerCodeCustomFieldId" :can-erp-create="canErpCreate" :can-erp-update="canErpUpdate" :can-erp-sync="canErpSync"></spectrum-contact>
					<sage-100-contact ref="sage100Contact"  v-if="sageAccess && sageContactMapping && company.is_residential" :company="company" :contact="contact" :user="user" :team="team" :contactMapping="sageContactMapping" :can-erp-create="canErpCreate" :can-erp-update="canErpUpdate" :can-erp-sync="canErpSync"></sage-100-contact>
					<sage-300-contact :custom-customer-code-field-id="getSafe(() => agaveErp.contact_field.custom_customer_field.follow_up_field)" :custom-contact-code-field-id="getSafe(() => agaveErp.contact_field.custom_contact_field.follow_up_field)" ref="Sage300Contact" v-if="agaveErp && agaveErp.third_party_name == 'sage-300-cre' && agaveErp.contact_field && company.is_residential" :company="company" :contact="contact" :user="user" :team="team" :contactMapping="agaveErp.contact_field" :can-erp-create="canErpCreate" :can-erp-update="canErpUpdate" :can-erp-sync="canErpSync"></sage-300-contact>
                     <foundation-contact ref="foundationContactComponent" v-if="foundationAccess && foundationMapping && company.is_residential" :company="company" :contacts="contact" :user="user" :team="team" :foundationContactMapping="foundationMapping" :foundationCustomerNoCustomFieldId="foundationCustomerCodeCustomFieldId" :can-erp-create="canErpCreate" :can-erp-update="canErpUpdate" :can-erp-sync="canErpSync"></foundation-contact>
                    <div class="dropdown float-left" v-if="quickBookAccess && company.is_residential == 1">
                        <button type="button"
                                class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                                id="quickBookDropDown" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">
                            <i v-if="connectingQuickBook" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                            QB Actions <i class="fa fa-caret-down mx-1"></i>
                        </button>
                        <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="quickBookDropDown">
                            <button type="button" class="dropdown-item py-2" @click="fetchInvoices()" v-if="!isQuickBookConnected">
                                Connect
                            </button>
                            <button type="button" class="dropdown-item py-2" @click="disconnectQuickBook()" v-else>
                                Disconnect
                            </button>
                            <button type="button" class="dropdown-item py-2" @click="syncInvoices()" v-if="isQuickBookConnected">
                                Sync QuickBooks
                            </button>
                            <button type="button" class="dropdown-item py-2" @click="goToCustomerOnQB()" v-if="isQuickBookConnected">
                                Go To Customer <i class="fa fa-external-link-square" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                    <button @click="pushContactToSageIntacct" v-if="canErpCreate && contactPushToSageIntacct && company.is_residential && !contact.sage_intacct_customer_no"
                            class="py-2 px-2 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                        <i v-if="pushToFoundationLoading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i> Push To Sage Intacct
                    </button>
                    <span class="text-green-foundation" v-if="contactPushToSageIntacct && company.is_residential && contact.sage_intacct_customer_no">Contact synced with Sage Intacct</span>

                </div>
            </div>
        </div>
        <div class="mb-12">
            <div class="row px-1" style="align-items: flex-start; margin: 0 auto;">
                    <div class="mr-3 col-md-3 rounded shadow-md bg-white mb-4">
                        <form @submit.prevent="saved" @keydown="form.errors.clear($event.target.name)"
                              class="">
                            <div class="border-b-2 border-followup-nav text-grey-darkest rounded-t p-2">
                                <span class="pl-2">Edit Contact</span>
                            </div>
                            <div class="p-0 rounded  w-full bg-white">
                                <a style="cursor: pointer;position: absolute;left: 81px;top: 109px;z-index: 1;"
                                v-if="contact.linkedin_profile_url" :href="prepareLinkedInURL(contact.linkedin_profile_url)" target="_blank">
                                    <img src="/images/linkedin-icon.png" style="width: 50px">
                                </a>
                                <div v-if="newlyCroppedImage" style="display: flex;position: relative;align-items: center;justify-content: center; padding-top: 10px;">
                                    <img class="circle" :src="newlyCroppedImage"/>
                                </div>
                                <div v-else-if="contact.photo_url" style="display: flex;position: relative;align-items: center;justify-content: center; padding-top: 10px;">
                                    <img class="circle" :src="contact.photo_url"/>
                                </div>
                                <!-- <div v-else-if="form.profileImage" style="display: flex;position: relative;align-items: center;justify-content: center; padding-top: 10px;"> -->
<!--                                    <span v-if="form.vanityName == 1">-->
<!--                                        <a :href="'https://www.linkedin.com/in/'+form.linkedin_vanity_name" style="left: 66%;top: 65%;color: rgb(0, 63, 103);position: absolute;" target="_blank"-->
<!--                                           class=""><i class="fa fa-linkedin-square fa-2x"></i></a>-->
<!--                                    </span>-->
<!--                                    <span v-else>-->
<!--                                        <a :href="this.linkedinUrl" style="left: 66%;top: 65%;color: rgb(0, 63, 103);position: absolute;"-->
<!--                                           class=""><i class="fa fa-linkedin-square fa-2x"></i></a>-->
<!--                                    </span>-->
                                    <!-- <img v-if="form.linkedin_profile_url" class="circle" :src="form.linkedin_profile_url"/>
                                </div> -->
                                <div v-else style="display: flex;position: relative;align-items: center;justify-content: center; padding-top: 10px;">
<!--                                    <a :href="this.linkedinUrl" style="left: 66%;top: 65%;color: rgb(0, 63, 103);position: absolute;"-->
<!--                                       class=""><i class="fa fa-linkedin-square fa-2x"></i></a>-->
                                    <img v-if="form.scrFileStatus == true" class="circle" :src="'https://logo.clearbit.com/'+this.form.emailDomain"/>
                                    <span v-else class="circle" style="font-size: 65px;color: #fff;text-align: center;"
                                          v-bind:style="{ 'background': bgColorDark }">{{ form.initals }}</span>

                                </div>
                                <span data-toggle="modal" data-target="#upload_photo" style="cursor: pointer;background: #01b1af;border-radius: 100%;padding: 4px 8px;color: white;position: relative;left: 175px;bottom: 37px;"><i class='fa fa-pencil'></i></span>

                                <div class="flex flex-row px-4 mb-3 w-full">
                                    <label class="text-grey-darkest text-sm" for="name"
                                           :class="{'text-red': form.errors.has('name')}" style="width: 30%">Name</label>
                                    <div style="width: 68%">
                                        <input style="width: 100%;padding: 5px 0 5px 10px; font-size: 14px" v-model="form.name" id="name" name="name" maxlength="64"
                                               class="bg-white leading-normal appearance-none border-1 rounded text-grey-darkest focus:outline-none ml-1"
                                               :class="{'border-red': form.errors.has('name')}">
                                        <div class="text-red" v-if="form.errors.has('name')">{{ form.errors.get('name') }}</div>
                                    </div>
                                </div>
                                <div class="flex flex-row px-4 w-full">
                                    <label class="text-grey-darkest text-sm" for="cell"
                                           :class="{'text-red': form.errors.has('cell')}" style="width: 30%">Cell</label>
                                    <div style="width: 70%" >
                                        <div class="input-group mb-3">
    <!--                                        <div class="input-group-prepend">
                                                            <span class="input-group-text" id="basic-addon1">
                                                                {{ symbols.DDI }}
                                                            </span>
                                            </div>-->
                                            <input style="width: 100%;padding: 5px 0 5px 10px; font-size: 14px" v-model="form.cell" id="cell" name="cell" maxlength="64"
                                                   v-mask="masks.v_mask_phone"
                                                   class="bg-white leading-normal appearance-none border-1 rounded text-grey-darkest focus:outline-none ml-1"
                                                   :class="{'border-red': form.errors.has('cell')}">
                                        </div>
                                        <div class="text-red" v-if="form.errors.has('cell')">{{ form.errors.get('cell') }}</div>
                                    </div>
                                </div>

                                <div class="flex flex-row justify-content-between mb-3 px-4" v-show="company.is_residential">
                                    <label class="text-grey-darkest text-sm" for="address"
                                           :class="{'text-red': form.errors.has('address')}">Address</label>
                                    <div style="width: 68%">
                                        <input v-model="form.address" id="searchTextField" name="address" maxlength="64"
                                               class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest text-sm w-full focus:outline-none"
                                               :class="{'border-red': form.errors.has('address')}">
                                        <div class="text-red text-sm" v-if="form.errors.has('address')">{{
                                                form.errors.get('address') }}
                                        </div>
                                        <input v-model="form.lat" type="hidden" name="lat"
                                               class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                                        <input v-model="form.lng" type="hidden" name="lng"
                                               class="rounded w-full p-2 text-grey-darkest text-sm focus:outline-none border-1">
                                    </div>
                                </div>

                                <div class="flex flex-row justify-content-between mb-3 px-4" v-show="company.is_residential">
                                    <label class="text-grey-darkest text-sm" for="city"
                                           :class="{'text-red': form.errors.has('city')}">City</label>
                                    <div style="width: 68%">
                                        <input v-model="form.city" type="text" name="city" id="city" maxlength="64"
                                               class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest text-sm w-full focus:outline-none"
                                               :class="{'border-red': form.errors.has('city')}">
                                        <div class="text-red text-sm" v-if="form.errors.has('city')">{{ form.errors.get('city') }}
                                        </div>
                                    </div>
                                </div>

                                <div class="flex flex-row justify-content-between mb-3 px-4" v-show="company.is_residential">
                                    <label class="text-grey-darkest text-sm" for="state"
                                           :class="{'text-red': form.errors.has('state')}">State</label>
                                    <div style="width: 68%">
                                        <input v-model="form.state" type="text" id="state" title="state" maxlength="64"
                                               class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest text-sm w-full focus:outline-none"
                                               :class="{'border-red': form.errors.has('state')}">
                                        <div class="text-red text-sm" v-if="form.errors.has('state')">{{ form.errors.get('state')
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <div class="flex flex-row justify-content-between mb-3 px-4" v-show="company.is_residential">
                                    <label class="text-grey-darkest text-sm" for="zip"
                                           :class="{'text-red': form.errors.has('zip')}">Zip</label>
                                    <div style="width: 68%">
                                        <input v-model="form.zip" type="text" id="zip" name="zip" maxlength="64"
                                               class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest text-sm w-full focus:outline-none"
                                               :class="{'border-red': form.errors.has('zip')}">
                                        <div class="text-red text-sm" v-if="form.errors.has('zip')">{{ form.errors.get('zip') }}
                                        </div>
                                    </div>
                                </div>

                                <div class="flex flex-row px-4 mb-3 w-full">
                                    <div class="flex flex-row" style="width: 30%">
                                        <label class="text-grey-darkest text-sm" for="email"
                                               :class="{'text-red': form.errors.has('email')}" >Email</label>
                                        <div class="ml-2 cursor-pointer text-center">
                                            <a :href="`mailto:${form.email}${mailSubject}`" target="_blank"
                                               class="material-icons text-3sm">mail</a>
                                        </div>
                                    </div>
                                    <div style="width: 68%">
                                        <input style="width: 100%;padding: 5px 0 5px 10px; font-size: 14px" v-model="form.email" id="email" name="email" maxlength="64"
                                               class="bg-white leading-normal appearance-none border-1 rounded text-grey-darkest focus:outline-none ml-1"
                                               :class="{'border-red': form.errors.has('email')}">
                                        <div class="text-red" v-if="form.errors.has('email')">{{
                                                form.errors.get('email')
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-row px-4 mb-3 w-full" v-if="!isContactResidentialActive || !contact.is_contact_residential">
                                    <div class="flex flex-row" style="width: 30%">
                                        <label class="text-grey-darkest text-sm" for="email"
                                               :class="{'text-red': form.errors.has('email')}" >Company Name</label>
                                    </div>
                                    <div style="width: 68%">
                                        <input style="width: 100%;padding: 5px 0 5px 10px; font-size: 14px" v-model="form.company_name" id="company_name" name="company_name" maxlength="64"
                                               class="bg-white leading-normal appearance-none border-1 rounded text-grey-darkest focus:outline-none ml-1"
                                               :class="{'border-red': form.errors.has('company_name')}" disabled>
                                        <div class="text-red" v-if="form.errors.has('company_name')">{{
                                                form.errors.get('company_name')
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-row px-4 mb-3 w-full" style="padding-right: 0 !important;">
                                    <label class="text-grey-darkest text-sm" for="title"
                                           :class="{'text-red': form.errors.has('title')}" style="width: 27%">Title</label>
                                    <div style="width: 63%">
                                        <input style="width: 100%;padding: 5px 0 5px 10px; font-size: 14px" v-model="form.title" id="title" title="title" maxlength="64"
                                               class="bg-white leading-normal appearance-none border-1 rounded text-grey-darkest focus:outline-none ml-1"
                                               :class="{'border-red': form.errors.has('title')}">
                                        <div class="text-red" v-if="form.errors.has('title')">{{
                                                form.errors.get('title')
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-row px-4 mb-3 w-full" style="padding-right:0 !important;">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red': form.errors.has('team_contact_status')}" style="width: 28%">Status</label>
                                    <div style="width: 63%">
                                        <select name="team_contact_status" id="team_contact_status" v-model="form.team_contact_status"
                                                @change="openStatusModal($event)"
                                                class="w-full bg-white border-1 rounded focus:outline-none px-2 text-grey-darkest text-sm select-height"
                                        >
                                            <option selected></option>
                                            <option v-for="item in contactStatuses" :value="item.id">{{ item.name }}</option>
                                        </select>
                                        <div class="text-red" v-if="form.errors.has('team_contact_status')">{{
                                                form.errors.get('team_contact_status')
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-row px-4 mb-3 w-full" style="padding-right: 0 !important;">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red': form.errors.has('user')}" style="width: 28%">User</label>
                                    <div style="width: 63%">
                                        <multiselect class="cursor-pointer" :options="users" v-model="form.user"
                                                     :show-labels="false" @input="form.errors.clear('user')"
                                                     track-by="id" label="name" value="id"></multiselect>
                                        <div class="text-red" v-if="form.errors.has('user')">{{
                                                form.errors.get('user')
                                            }}
                                        </div>
                                        <div class="text-red" v-else-if="user_error">{{
                                                user_error
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-row  px-4 mb-3 w-full" style="padding-right: 0 !important;">
                                    <label class="text-grey-darkest text-sm"
                                           :class="{'text-red': form.errors.has('contact_type_id')}" style="width: 28%">Type</label>
                                    <div style="width: 63%">
                                        <multiselect
                                            class="cursor-pointer w-full"
                                            :options="contactTypes"
                                            v-model="selectedType"
                                            :show-labels="false"
                                            @input="form.errors.clear('contact_type_id')"
                                            track-by="id"
                                            label="code"
                                            value="id"
                                            :disabled="isContactResidentialActive && contact.is_contact_residential">
                                        </multiselect>
                                        <div class="text-red" v-if="form.errors.has('contact_type_id')">
                                            {{ form.errors.get('contact_type_id') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-row px-4 mb-3 w-full" style="padding-right: 0 !important;">
                                    <label class="text-grey-darkest text-sm" for="created_at"
                                           :class="{'text-red': form.errors.has('created_at')}" style="width: 27%">Created date</label>
                                    <div style="width: 63%">
                                        <input style="width: 100%;padding: 5px 0 5px 10px; font-size: 14px" v-model="this.contactCreatedDate" id="created_at" maxlength="64"
                                               class="bg-white leading-normal appearance-none border-1 rounded text-grey-darkest focus:outline-none ml-1"
                                               :class="{'border-red': form.errors.has('created_at')}" disabled>
                                        <div class="text-red" v-if="form.errors.has('created_at')">{{
                                                form.errors.get('created_at')
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-row px-4 mb-3 w-full" style="padding-right: 0 !important;">
                                    <label class="text-grey-darkest text-sm" for="updated_at"
                                           :class="{'text-red': form.errors.has('updated_at')}" style="width: 27%">Last update</label>
                                    <div style="width: 63%">
                                        <input style="width: 100%;padding: 5px 0 5px 10px; font-size: 14px" v-model="this.contactUpdatedDate" id="updated_at" maxlength="64"
                                               class="bg-white leading-normal appearance-none border-1 rounded text-grey-darkest focus:outline-none ml-1"
                                               :class="{'border-red': form.errors.has('updated_at')}" disabled>
                                        <div class="text-red" v-if="form.errors.has('updated_at')">{{
                                                form.errors.get('updated_at')
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <contact-custom-fields ref="ContactCustomFields" :contact="contact" base="edit" :foundationCustomerAccess="foundationCustomerAccess" :foundationAutoGeneratedAccess="foundationAutoGeneratedAccess" :foundationAccess="foundationAccess" :foundationCustomerCodeCustomFieldId="foundationCustomerCodeCustomFieldId" :spectrumCustomerCodeCustomFieldId="spectrumCustomerCodeCustomFieldId" :spectrumAccess="spectrumAccess" :spectrumContactMapping="spectrumContactMapping" @spectrum-customer-code-changed="spectrumCustomerCodeChanged" :agave-erp="agaveErp"></contact-custom-fields>

                                <div class="flex flex-row justify-end mt-3 mb-2 pr-4">
                                    <button v-if="canEdit && !sharedCompanyObj.isSharedCompany" @click.prevent="showMergeContactForm = true"
                                            class="mr-2 py-1 px-2 rounded-full flex flex-row items-center justify-center focus:outline-none hover:bg-teal-dark bg-teal">
                                        <span class="text-white font-bold">Merge</span>
                                    </button>
                                    <button v-if="canDelete && !sharedCompanyObj.isSharedCompany" @click="destroy" href="#"
                                            class="mr-2 py-1 px-2 rounded-full flex flex-row items-center justify-center focus:outline-none hover:bg-teal-dark bg-teal">
                                        <span class="text-white font-bold">Delete</span>
                                    </button>
                                    <a v-if="canEdit || assignedUserID == this.currentUserId || assignedUserID == 0" :href="`/company/${company.id}`"
                                       class="mr-2 py-1 px-2 border-1 border-followup-nav hover:bg-followup-nav hover:text-white text-followup-nav rounded-full focus:outline-none">
                                        Cancel
                                    </a>
                                    <button v-if="((canEdit || assignedUserID == this.currentUserId || assignedUserID == 0) && (!sharedCompanyObj.isSharedCompany || (sharedCompanyObj.access !== null && sharedCompanyObj.access !== 'view')))"
                                        class="py-1 px-2 rounded-full flex flex-row items-center justify-center focus:outline-none hover:bg-teal-dark"
                                        :class="{'bg-teal-lighter cursor-not-allowed' : form.errors.any(), 'bg-teal' : !form.errors.any()}"
                                        :disabled="form.errors.any() && !canEdit">
                                        <span class="text-white font-bold">Update</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div v-if="!sharedCompanyObj.isSharedCompany" class="flex border-b-2 border-followup-nav text-grey-darkest rounded-t p-2 justify-between">
                            <span class="pl-2">Contact Analytics</span>
                        </div>
                        <slot v-if="!sharedCompanyObj.isSharedCompany"></slot>
                    </div>
                    <div class="mr-3 col-md-8 rounded shadow-md bg-white p-0">
                        <div class="mb-2 w-full border-b-0 border-followup-nav contactTabs">
                            <button v-for="tab in tabs" :key="tab" @click="selected = tab;"
                                    :class="['tab-btn', { active: selected === tab }, {'w-auto': tab === 'AssociatedCompanies'}]">
                                {{ tab === "AssociatedCompanies" ? "Associated Companies" : tab }}
                            </button>
                            <keep-alive>
                                <component :is="selected" class="tab tab-body-custom-class" :company="this.company" :contact="this.contact" :exchange="exchange" :user="this.users" :canEdit="canEdit" :currentUserId="currentUserId" :assignedUserID="assignedUserID" :hasSequencesAccess="hasSequencesAccess" :calendar="calendar" :teamId="teamId" :masks="masks" :sharedCompanyObj="sharedCompanyObj" :field-labels="fieldLabels" :current-user="user" :team="team" :symbols="symbols" :contactProjectState="contactProjectState" :contactProjectAvailableSort="contactProjectAvailableSort" :contactProjectAvailableColumns="contactProjectAvailableColumns" :recordDetailFieldLabels="recordDetailFieldLabels"
                                           :agaveErp="agaveErp" :residentialContactErpSyncSettings="erpSyncSettings" :vistaContactMapping="vistaContactMapping" :spectrumContactMapping="spectrumContactMapping" :sageContactMapping="sageContactMapping" :foundationMapping="foundationMapping">
                                    <slot></slot>
                                </component>
                            </keep-alive>
                        </div>
                        <div class="">
                            <div class="mb-3 w-full border-b-2 bg-primary contactTabs text-white py-2 px-3 mt-3" v-if="isQuickBookConnected && company.is_residential == 1">
                                Invoices <span class="cursor-pointer" @click="syncInvoices()"><i class="fa fa-refresh" aria-hidden="true"></i></span> <span v-if="quickBookInvoiceObj" class="float-right">Last Synced: {{ formatSyncedDate(quickBookInvoiceObj.updated_at) }}</span>
                            </div>
                            <div class="container" v-if="isQuickBookConnected && company.is_residential == 1">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>Invoice</th>
                                        <th>Balance</th>
                                        <th>Doc Number</th>
                                        <th>Due Date</th>
                                        <th>Total Amount</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="quickBookInvoiceData.length > 0">
                                        <tr v-for="(invoice, index) in quickBookInvoiceData" class="cursor-pointer hover:bg-grey-lighter" @click="invoiceDetailModal(invoice)">
                                            <td>Invoice {{index+1}}</td>
                                            <td>${{ invoice.Balance }}</td>
                                            <td>{{ invoice.DocNumber }}</td>
                                            <td>{{ formatQuickBookDate(invoice.DueDate) }}</td>
                                            <td>${{ invoice.TotalAmt }}</td>
                                            <td class="text-center"><i class="fa fa-eye" aria-hidden="true"></i></td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="11" class="text-center">No invoices found in QB for this company/customer</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
            </div>
        </div>

        <div class="modal" id="exist_contact" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 400px;">
                    <div class="modal-header">
                        <div class="row" style="height: 200px;">
                            <div class="col-md-12" style="text-align: center; font-size:25px; margin-top:15px;font-weight: bold;">This contact already exists</div>
                            <div class="col-md-12" style="text-align: center;" data-dismiss="modal">
                                <button type="button" @click="pageReload" class="btn btn-primary" style="padding: 15px 40px;box-shadow: #989797 0px 0px 5px 2px;margin-right: 12px;"
                                > Cancel</button>
                                <button type="button" @click="contactDetails()" class="btn btn-default" style="padding: 15px 40px;box-shadow: #989797 0px 0px 5px 2px; background:rgb(152 151 151);color: white;"
                                >Add</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="contactStatusModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 500px; margin: 0 auto;">
                    <div class="modal-header">
                        <div class="row" style="height: 150px;">
                            <h3 class="w-100 text-center mt-2">Move contact to new company?</h3>
                            <div class="col-md-12" style="text-align: center;" data-dismiss="modal">
                                <button type="button" @click="openMoveContactModal" class="btn btn-primary mr-2" style="padding: 8px 35px;box-shadow: #989797 0px 0px 5px 2px;"
                                >Yes</button>
                                <button type="button" data-dismiss="modal" target="_blank" @click="closeContactStatusModal" class="btn btn-default ml-2" style="padding: 8px 35px;box-shadow: #989797 0px 0px 5px 2px; background:rgb(152 151 151);color: white;"
                                >No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="moveContactModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style="border-radius: 12px; overflow: hidden;width: 500px; margin: 0 auto;">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeMoveContactModal">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <div class="flex flex-column px-2 mb-3 w-full">
                                    <label class="text-grey-darkest" for="move_company_id">Add to Existing Company</label>
                                    <div>
                                        <multiselect v-model="move_contact.company"
                                                     id="move_company_id"
                                                     placeholder="select Company"
                                                     :options="companies"
                                                     :multiple="false"
                                                     track-by="id"
                                                     label="name"
                                                     :taggable="false"
                                                     :close-on-select="true">
                                        </multiselect>
                                        <span class="text-red text-sm" v-if="move_contact.company_error">{{ move_contact.company_error }}</span>
                                    </div>
                                </div>
                                <div class="flex flex-column px-2 mb-3 w-full">
                                    <label class="text-grey-darkest text-sm" for="contact_new_email">Enter contacts new email</label>
                                    <div>
                                        <input style="width: 100%;padding: 5px 0 5px 10px; font-size: 14px" id="contact_new_email" v-model="move_contact.new_email" name="contact_new_email" type="email" placeholder="Enter contacts new email"
                                               class="bg-white leading-normal appearance-none border-1 rounded text-grey-darkest focus:outline-none">
                                        <span class="text-red text-sm" v-if="move_contact.new_email_error">{{ move_contact.new_email_error }}</span>
                                    </div>
                                </div>
                                <div class="flex justify-content-end p-2">
                                    <button type="button" @click="saveContactToCompany" class="btn btn-primary" style="padding: 8px 35px;box-shadow: #989797 0px 0px 5px 2px;margin-right: 12px;"
                                    >Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade bd-example-modal-xl" id="upload_photo" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Update Contact Image</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-center">
                        <div id="cropperModel" class="model_loader">
                            <div class="text-5xl text-teal text-center model_spinner">
                                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                            </div>
                        </div>
                        <vue-anka-cropper
                                    :options="{
                                    aspectRatio: 1,
                                    closeOnSave: false,
                                    cropArea: 'circle',
                                    croppedHeight: 400,
                                    croppedWidth: 400,
                                    dropareaMessage: 'Upload file or drag and drop',
                                    frameLineDash: [0,0],
                                    frameStrokeColor: 'rgba(255, 255, 255, 1.0)',
                                    handleFillColor: 'rgba(255, 255, 255, 1.0)',
                                    handleHoverFillColor: 'rgba(255, 255, 255, 1.0)',
                                    handleHoverStrokeColor: 'rgba(255, 255, 255, 1.0)',
                                    handleSize: 13,
                                    handleStrokeColor: 'rgba(255, 255, 255, 0.1)',
                                    overlayFill: 'rgba(0, 0, 0, 0.1)',
                                    previewOnDrag: true,
                                    selectButtonLabel: 'Select File',
                                    showPreview: true,
                                    previewQuality: 1,
                                    resultQuality: 1,
                                    skin: 'light',
                                    layoutBreakpoint: 480,
                                    uploadData: {},
                                    uploadTo: false
                                }"
                                @cropper-error="handleCroppingError(errorMessage)"
                                @cropper-saved="getCroppedImage($event)"
                                ></vue-anka-cropper>
                    </div>
                </div>
            </div>
        </div>

        <div class="proposal-overlay" v-if="loading">
            <div class="text-5xl text-grey-darkest text-center loading-custom">
                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
            </div>
        </div>

        <MergeContact v-if="showMergeContactForm" @modalClosed="showMergeContactForm = false" :primaryContactObj="contact" ></MergeContact>

    </div>
</template>

<script>

import Form from "../../utils/form";
import Multiselect from 'vue-multiselect';
import Projects from "../company/recent-projects";
import Notes from "./contact-notes";
import Emails from "./contact-emails";
import ContactCustomFields from "./custom-fields/contact-custom-fields";
import Activities from "./contact-activities";
import Logs from "./contact-activity-logs";
import AssociatedCompanies from "./associated-companies.vue";
import Swal from "sweetalert2";
import vueAnkaCropper from 'vue-anka-cropper';
var x = 137;
var y = 100+ Math.floor(Math.random() * 256);
var z = 50+ Math.floor(Math.random() * 256);
import MergeContact from "./merge-contact";
import FoundationContact from "./agave/foundation-contact.vue";
import VistaContact from "./agave/vista-contact.vue";
let autocomplete=null;
export default {
    name: 'contact-edit',
    props: ['sageAccess','sageContactMapping' ,  'agaveErp' ,'company', 'contact', 'masks', 'symbols','canEdit', 'currentUserId', 'hasSequencesAccess', 'calendar', 'teamId','linkedinUrl','exchange',  'canDelete', 'contactStatuses', 'sharedCompanyObj', 'fieldLabels', 'foundationCustomerAccess', 'foundationAutoGeneratedAccess', 'foundationPullDataAccess', 'contactPushToFoundation','contactPushToSageIntacct', 'contactCustomCustomerNoField', 'isContactCustomCustomerNoAutoGenerated', 'vistaAccess', 'quickBookAccess', 'quickBookInvoices', 'user', 'team', 'isContactResidentialActive', 'spectrumAccess','spectrumContactMapping', 'spectrumCustomerCodeCustomFieldId','foundationAccess','foundationMapping','foundationCustomerCodeCustomFieldId', 'contactProjectState', 'contactProjectAvailableSort', 'contactProjectAvailableColumns', 'checkCompanyContactMapping', 'recordDetailFieldLabels',
            'residentialContactErpSyncSettings', 'erpConnections', 'canErpCreate', 'canErpUpdate', 'canErpSync'],
    components: {
        VistaContact,
        FoundationContact,
        Multiselect, Projects, Notes, Emails, ContactCustomFields, Activities,vueAnkaCropper,MergeContact, AssociatedCompanies},
    data() {
        return {
            form: new Form({
                name: this.contact.name,
                address: this.contact.address,
                city: this.contact.city,
                state: this.contact.state,
                zip: this.contact.zip,
                initals: this.contact.name.replace(/\s/g, '').charAt(0),
                cell: this.contact.cell ? this.contact.cell.replace(/\D/g, '') : '',
                email: this.contact.email,
                title: this.contact.title,
                contact_status: this.contact.contact_status,
                team_contact_status: this.contact.team_contact_status,
                date: this.contact.last_meeting.date,
                completed: this.contact.last_meeting.completed,
                user: this.contact.user ?? this.contact.last_meeting.user,
                contact_types_id: null,
                company_name:this.company.name,
                contact_id: null,
                company_id:null,
                linkedin_profile_url: this.contact.linkedin_profile_url,
                profileImage: this.contact.linkedin_profile_url ? 1 : '',
                linkedin_vanity_name: this.contact.linkedin_vanity_name,
                vanityName: this.contact.linkedin_vanity_name ? 1 : '',
                emailDomain: this.contact.email ? this.contact.email.split('@')[1] ?? '' : '',
                scrFileStatus: false,
                sales_behaviors:[],
                followup_complete:0,
                customFieldsData: null
            }),
            newlyCroppedImage : null,
            users: [],
            contactTypes: [],
            selectedType: null,
            tabs: ["Notes","Projects", "Emails", "Activities"],
            selected: "Notes",
            contactCreatedDate: null,
            contactUpdatedDate: null,
            assignedUserID: null,
            bgColorDark : "rgb(" + x + "," + y + "," + z + ")",
            companies: [],
            move_contact: {
                company: null,
                company_error: '',
                new_email: '',
                new_email_error: '',
                detach_projects: false
            },
            loading: false,
            user_error:'',
            is_sales_behavior_changed: 'false',
            residential_contact_type_id: null,
            syncFromFoundationLoading: false,
            pushToFoundationLoading: false,
            isQuickBookConnected: (this.contact.quick_book_connected == 1)? true:false,
            connectingQuickBook: false,
            quickBookCustomers: [],
            selectedQuickBookCustomer: null,
            connectedQBCustomer: this.contact.quick_book_customer_id,
            selectedCompanyContactForQB: null,
            quickBookInvoiceObj: this.quickBookInvoices ?? null,
            quickBookInvoiceData: (this.quickBookInvoices)? JSON.parse(this.quickBookInvoices.quick_book_invoice_data):[],
            invoiceDetail: null,
			showMergeContactForm: false,
            erpSyncSettings: null,
            vistaContactMapping: null,
        }
    },
    mounted() {
        console.log('foundationAccess',this.foundationAccess,'foundationMapping',this.foundationMapping,'foundationCustomerCodeCustomFieldId',this.foundationCustomerCodeCustomFieldId);
        this.initAutocomplete();
        this.assignedUserID = this.form.user ? this.form.user.id : 0;
        this.contactCreatedDate = this.contact.created_at ? moment(this.contact.created_at).utc(1).format("MM-DD-YYYY hh:mm A") : null;
        this.contactUpdatedDate = this.contact.updated_at ? moment(this.contact.updated_at).utc(1).format("MM-DD-YYYY hh:mm A") : null;
        Bus.$on('sendFollowUpDate', data => {
            this.form.date = data.followupDate;
            this.form.followup_complete = data.followupComplete;
        });
        Bus.$on('sendSaveActivities', data => {
            this.form.sales_behaviors= data;
            this.saved();
        });
        Bus.$on('userRequiredError', data => {
            if(data !== null && data.errors.user[0] !== null) {
                this.user_error =data.errors.user[0];
            }
        });
        if(this.sharedCompanyObj.isSharedCompany) {
            this.tabs = ["Notes"];
        }
        if(!this.company.is_residential) {
            this.tabs.push("AssociatedCompanies");
        }
        if(this.residentialContactErpSyncSettings){
            this.erpSyncSettings = this.residentialContactErpSyncSettings
        }
        Bus.$on('vistaContactConnectionDataChanged', data => {
            this.vistaContactMapping = data.vistaContactMapping;
            this.erpSyncSettings = data.residentialContactErpSyncSettings;
        });
    },
    watch: {
        selectedType(val) {
            this.form.contact_types_id = val ? val.id : null;
        },
        'form.user': function (value) {
            this.contact.last_meeting.user = value;
            Bus.$emit('changeUserFormContact', value);
        },
        'form.email': function (value) {
            // this.form.emailDomain = this.form.email ? this.form.email.split('@')[1] ?? '' : '';
            this.scrFileStatus();
        },
        'selected': function (value) {
            if(value === 'Activities'){
                this.is_sales_behavior_changed = 'true'
            }
        },
    },
    created() {
        this.fetchData();
        this.fetchSalesBehaviors();
        this.scrFileStatus();
    },
    computed:{
        mailSubject() {
            return `?subject=(${this.form.name} - ${this.contact.id})`;
        },
    },
    methods: {
        prepareLinkedInURL(url)  {
            let baseUrl = "https://www.linkedin.com/";
            if (!url.startsWith(baseUrl) && !url.startsWith("www.linkedin.com/") && !url.startsWith("linkedin.com/")) {
                url = baseUrl + url;
            }
            return url;
        },
        scrFileStatus()  {
            const self = this;
            var imageUrl = 'https://logo.clearbit.com/'+self.form.emailDomain;
            self.imageExists(imageUrl, function(exists) {
                self.scrFileExists(exists);
            });
        },
        handleCroppingError(errorMessage){
            Swal.fire("Uh oh!", errorMessage, "error");
        },
        getCroppedImage(event){
            $('#cropperModel').fadeIn();
            let formData = new FormData();
            formData.append('photo', event.croppedFile);
            axios.post(route('api.contact.updatePhoto', {contact: this.contact.id}),formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((response) => {
                        this.newlyCroppedImage = event.croppedImageURI;
                        $('#cropperModel').fadeOut();
                        $('#upload_photo').modal('hide');
                    });
        },
        imageExists(url, callback) {
            var img = new Image();
            img.onload = function() { callback(true); };
            img.onerror = function() { callback(false); };
            img.src = url;
        },
        scrFileExists(exists){
            this.form.scrFileStatus = exists;
        },
        fetchSalesBehaviors() {
            let self = this;
            axios.get(route('contact.sales-behaviors', {contactId: self.contact.id})).then(({data}) => {
                self.form.sales_behaviors = data.data;
            });
        },
        saved() {
            $('#saveContactActivityButton').attr("disabled", true);
            let self = this;
            if(!self.syncFromFoundationLoading) {
                self.form.customFieldsData = self.$refs.ContactCustomFields.form;
                if (!this.form.user || !this.form.user.id){
                    this.form.user = null;
                }

                this.form.put(route('api.contact.update', {contact: this.contact.id, is_sales_behavior_changed: this.is_sales_behavior_changed})).then((response) => {
                    $('#saveContactActivityButton').attr("disabled", false);
                    if (response.exists){
                        this.form.contact_id = response.contact_id;
                        this.form.company_id = response.company_id;
                        $('#exist_contact').modal('show');
                    }else {
                        this.$refs.ContactCustomFields.submit(self.contact.id, response.foundationCustomerNo);
                        this.selected = 'Activities';
                        this.$nextTick(() => {
                            Bus.$emit('sendSaveRequest', {'oldContact': response.oldContact, 'oldMeeting': response.oldMeeting, 'oldCustomFieldValues': response.oldCustomFieldValues});
                        });
                        self.getToast().fire({
                            type: 'success',
                            title: response.message,
                        });
                        if(self.foundationCustomerAccess && !response.foundationCustomerNo && response.foundationMsg !== '') {
                            self.getToast().fire({
                                type: 'error',
                                title: response.foundationMsg,
                            });
                            $('#saveContactActivityButton').attr("disabled", false);
                        }
                        else {
                            $('#saveContactActivityButton').attr("disabled", false);
                        }
                    }
                }).catch((error) => {
                    $('#saveContactActivityButton').attr("disabled", false);
                });
            }
        },
        goBack() {
            if(this.company.is_residential){
                window.location = "/contact";
            }else{
                window.location = "/company/" + this.company.id;
            }
        },
        pageReload(){
            window.location.reload();
        },
        contactDetails(){
            window.location = "/company/" + this.form.company_id +"/contact/"+this.form.contact_id+"/edit";
        },

        getUsers() {
            let self = this;
            axios.get(route('api.contact.users',{contact_id: self.contact.id})).then(({data}) => {
                self.users = [{id:null,name:''},...data];
            });
        },

        getContactTypes() {
            let self = this;
            axios.get(route('api.settings.codes.contact-type.index', {contact_id:self.contact.id})).then(({data}) => {
                self.residential_contact_type_id = data.find(x => x.is_residential).id
                if(self.contact.contact_types_id && self.residential_contact_type_id && self.contact.contact_types_id === self.residential_contact_type_id){
                    self.contactTypes = data.filter(x => x.is_residential);
                }else{
                    self.contactTypes = data.filter(x => !x.is_residential);
                }

                self.contactTypes.push({id: null, code: ""})
            }).finally(() => {
                if (self.contact.contact_types_id)
                    self.selectedType = self.contactTypes.find((contact) => {
                        return self.contact.contact_types_id === contact.id
                    });
                else
                    self.selectedType = null;
            });
        },
        fetchData() {
            this.getCompanyTypes();
            this.getUsers();
            this.getContactTypes();
            this.getCompanies();
        },
        getCompanies() {
            let self = this;
            axios.get(route('api.company.companies')).then(({data}) => {
                self.companies = data.data;
            });
        },
        openStatusModal() {
            this.$nextTick(() => {
                if(this.contactStatuses.length > 0){
                    this.contactStatuses.forEach(item => {
                        if(item.id == this.form.team_contact_status){
                            if(item.name.toLowerCase() == 'inactive'){
                                $('#contactStatusModal').modal('show');
                            }
                        }
                    });
                }
            });
        },
        openMoveContactModal() {
            $('#moveContactModal').modal('show');
        },
        saveContactToCompany() {
            let self = this;
            if(!self.move_contact.new_email || self.move_contact.company == null) {
                if(!self.move_contact.new_email) {
                    self.move_contact.new_email_error = 'Contact new email is required.'
                }
                if(self.move_contact.company == null) {
                    self.move_contact.company_error = 'Company is required.'
                }
                return false;
            }

            let emailRegex = /\S+@\S+\.\S+/;
            if(!emailRegex.test(self.move_contact.new_email)){
                self.move_contact.new_email_error = 'Contact new email is invalid.'
                return false;
            }

            let contact_data = {
                company_id: self.move_contact.company.id,
                new_email: self.move_contact.new_email,
                current_contact_id: self.contact.id,
            }
            this.loading = true;

            axios.post(route('api.contact.move-contact-check'), contact_data).then(({data}) => {
                if (data.exists){
                    Swal.fire({
                        title: 'Company Contact Already Exists',
                        text: 'Do you want to create duplicate contact',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'Continue Creating',
                        closeOnConfirm: false,
                    }).then((resultOther) => {
                        if (resultOther.value) {
                            this.moveContactAfterCheck(contact_data);
                        }
                    });
                }
                else {
                    this.moveContactAfterCheck(contact_data);
                }
            });

        },
        moveContactAfterCheck(contact_data){
            axios.post(route('api.contact.move-contact'), contact_data).then(({data}) => {
                $('#moveContactModal').modal('hide');
                this.$refs.ContactCustomFields.submit(data.contact.id);
                this.move_contact.company = null;
                this.move_contact.new_email = '';
                this.loading = false;
                this.getToast().fire({
                    type: 'success',
                    title: 'Inactive and Moved'
                });
                window.location = route('contact-list');
            });
        },
        getCompanyTypes() {
            let self = this;
            axios.get(route('api.settings.codes.company-type.index')).then(({data}) => {
                self.companyTypes = data;
                self.companyTypes.push({id: null, code: ""})
            }).finally(() => {
                if (self.company.company_types_id)
                    self.selectedType = self.companyTypes.find((company) => {
                        return self.company.company_types_id === company.id
                    });
                else
                    self.selectedType = null;
            });
        },
        destroy() {
            event.preventDefault();
            if(this.contact.agave_customer_no && this.contact.vista_customer_no && this.checkCompanyContactMapping){
                Swal.fire({
                    title: 'Uh oh!',
                    text: "Contact is synced with Vista. Please push another contact from company page and then try again.",
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#01B1AF',
                });
            }else{
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: false,
                    showConfirmButton: false,
                    html: `<br>
                    <button type="button" id="deleteBtn" class="btn btn-primary" style="background-color:#01B1AF;">Yes, delete it!</button>
                    <button type="button" id="moveBtn" class="btn btn-primary" style="background-color:#01B1AF;">Move and inactive</button>
                    <button type="button" id="cancelBtn" class="btn btn-secondary">Cancel</button>`,
                    onBeforeOpen: () => {
                        const moveBtn = document.querySelector('#moveBtn')
                        const deleteBtn = document.querySelector('#deleteBtn')
                        const cancelBtn = document.querySelector('#cancelBtn')

                        moveBtn.addEventListener('click', () => {
                            Swal.close();
                            $('#moveContactModal').modal('show');
                        })

                        deleteBtn.addEventListener('click', () => {
                            this.loading = true;
                            Swal.close();
                            axios.delete(route('api.contact.destroy', {contact: this.contact.id})).then(({data}) => {

                                if (data.status === "error") {
                                    this.loading = false;
                                    Swal.fire({
                                        title: 'Do you still want to delete the contact?',
                                        text: data.message,
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#01B1AF',
                                        confirmButtonText: 'Yes, delete it!'
                                    }).then((result) => {
                                        if (result.value) {
                                            this.move_contact.detach_projects = true;
                                            this.loading = true;
                                            axios.delete(route('api.contact.destroy', {contact: this.contact.id, detach_projects: this.move_contact.detach_projects})).then(() => {
                                                this.loading = false;
                                                this.getToast().fire({
                                                    type: 'success',
                                                    title: 'Contact has been deleted'
                                                });
                                                window.location = route('contact-list');
                                            });
                                        }
                                    });

                                } else {
                                    this.loading = false;
                                    this.getToast().fire({
                                        type: 'success',
                                        title: 'Your Contact has been deleted'
                                    });
                                    window.location = route('contact-list');
                                }
                            });
                        })

                        cancelBtn.addEventListener('click', () => {
                            Swal.close();
                        })
                    }
                })
            }

        },
        closeContactStatusModal(){
            $('#contactStatusModal').modal('hide');
        },
        closeMoveContactModal(){
            $('#moveContactModal').modal('hide');
        },
        syncFromFoundationValidation() {
            let self = this;
            self.syncFromFoundationLoading = true;
            let payload = {'contact': self.contact, 'customFieldsData': self.$refs.ContactCustomFields.form};

            axios.post(route('api.contact.sync-from-foundation-validation'), payload).then((data) => {
                if(data.data.pass) {
                    if(data.data.message == '') {
                        self.syncFromFoundation(data.data.customerNo);
                    }
                    else {
                        Swal.fire({
                            title: 'Foundation',
                            text: data.data.message,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#01B1AF',
                            confirmButtonText: 'Confirm'
                        }).then((result) => {
                            if (result.value) {
                                self.syncFromFoundation(data.data.customerNo);
                            }
                        });
                    }
                }
                else {
                    self.syncFromFoundationLoading = false;
                    self.getToast().fire({
                        type: 'error',
                        title: data.data.message
                    });
                }
            }).catch((error) => {
                self.syncFromFoundationLoading = false;
                self.getToast().fire({
                    type: 'error',
                    title: 'Some error occurred!',
                });
            });
        },
        syncFromFoundation(customerNo) {
            let self = this;
            let payload = {'contact': self.contact, 'customerNo': customerNo};

            axios.post(route('api.contact.sync-from-foundation'), payload).then((data) => {
                self.syncFromFoundationLoading = false;
                if(data.data.success) {
                    self.getToast().fire({
                        type: 'success',
                        title: data.data.message,
                    });
                    window.location.reload();
                }
                else {
                    window.location.reload();
                }
            }).catch((error) => {
                self.syncFromFoundationLoading = false;
            });
        },
        pushContactToFoundation() {
            let self = this;
            self.pushToFoundationLoading = true;
            if(self.contactCustomCustomerNoField && !self.isContactCustomCustomerNoAutoGenerated && self.$refs.ContactCustomFields.form.hasOwnProperty(self.contactCustomCustomerNoField.id) && (self.$refs.ContactCustomFields.form[self.contactCustomCustomerNoField.id] === undefined || self.$refs.ContactCustomFields.form[self.contactCustomCustomerNoField.id] === null || self.$refs.ContactCustomFields.form[self.contactCustomCustomerNoField.id] === '')) {
                self.pushToFoundationLoading = false;
                self.getToast().fire({
                    type: 'error',
                    title: 'Please enter Foundation customer #'
                });
            }
            else {
                let payload = {
                    'contact': self.contact,
                    'company': self.company,
                    'customerNo': self.contactCustomCustomerNoField && self.$refs.ContactCustomFields.form.hasOwnProperty(self.contactCustomCustomerNoField.id) ? self.$refs.ContactCustomFields.form[self.contactCustomCustomerNoField.id] : '',
                    'isContactHasCustomCustomerNoField': !!self.contactCustomCustomerNoField,
                    'isContactCustomCustomerNoAutoGenerated': self.isContactCustomCustomerNoAutoGenerated,
                };
                axios.post(route('api.contact.foundation.push-residential-contact'), payload).then((result) => {
                    self.pushToFoundationLoading = false;
                    if(result.data.foundationCustomerNo) {
                        self.contact.foundation_customer_no = result.data.foundationCustomerNo;
                        if(self.contactCustomCustomerNoField && self.$refs.ContactCustomFields.form.hasOwnProperty(self.contactCustomCustomerNoField.id)) {
                            self.$refs.ContactCustomFields.form[self.contactCustomCustomerNoField.id] = result.data.foundationCustomerNo;
                        }
                    }
                    self.getToast().fire({
                        type: result.data.foundationCustomerNo ? 'success' : 'error',
                        title:  result.data.message,
                    });
                }).catch(() => {
                    self.pushToFoundationLoading = false;
                    self.getToast().fire({
                        type: 'error',
                        title:  'Create/Update on Foundation Failed.'
                    });
                });
            }
        },
        fetchInvoices(){
            let self = this;
            if(self.contact.email == null || self.contact.email == ''){
                self.getToast().fire({
                    type: 'error',
                    title: 'Please enter a valid email address to contact'
                });
                return false;
            }
            self.connectingQuickBook = true;
            let payload = {'company': self.company, 'contact': self.contact };
            axios.post(route('quick-book.fetch-invoices'), payload).then(response => {
                if(response.data.status == 'success'){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    self.quickBookInvoiceObj = response.data.quickBookInvoices;
                    self.quickBookInvoiceData = JSON.parse(response.data.quickBookInvoices.quick_book_invoice_data);
                    self.connectedQBCustomer = response.data.connectedCustomerId;
                    self.isQuickBookConnected = true;

                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                    self.quickBookCustomers = response.data.quickBookCustomers
                    self.selectOptionsForQuickBook();
                }
                self.connectingQuickBook = false;
            });
        },
        formatQuickBookDate(date){
            return moment(date).format("MM-DD-yyyy");
        },
        formatQuickBookDateTime(date){
            return moment(date).format("MM-DD-yyyy h:mm a");
        },
        invoiceDetailModal(invoice){
            this.invoiceDetail = invoice;
            this.$nextTick(() => {
                $('#invoiceDetailModal').modal('show');
            });
        },
        disconnectQuickBook(){
            let self = this;
            let payload = {'company': self.company, 'quickBookInvoiceId': self.quickBookInvoiceObj.id, 'contact': self.contact };
            axios.post(route('quick-book.disconnect'), payload).then(response => {
                if(response.data.status == 'success'){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.isQuickBookConnected = false;
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        formatSyncedDate(lastSync) {
            return moment.utc(lastSync).local().format("MM-DD-yyyy h:mm a");
        },
        syncInvoices(){
            let self = this;
            self.connectingQuickBook = true;
            let payload = {'company': self.company, 'contact': self.contact };
            axios.post(route('quick-book.sync-invoices'), payload).then(response => {
                if(response.data.status == 'success'){
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    self.quickBookInvoiceObj = response.data.quickBookInvoices;
                    self.quickBookInvoiceData = JSON.parse(response.data.quickBookInvoices.quick_book_invoice_data);
                    self.isQuickBookConnected = true;
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
                self.connectingQuickBook = false;
            });
        },
        goToCustomerOnQB(){
            let QBurl = process.env.MIX_QUICK_BOOK_ACCOUNT_BASE_URL;
            window.open(QBurl+"app/customerdetail?nameId="+this.connectedQBCustomer, "_blank");
        },
        selectOptionsForQuickBook(){
            $('#optionsForQuickBookModal').modal('show');
        },
        selectOptionsForQuickBookClose(){
            $('#optionsForQuickBookModal').modal('hide');
        },
        selectFromExistingQBCustomersModal(){
            this.selectedQuickBookCustomer = null;
            this.selectOptionsForQuickBookClose();
            $('#selectFromExistingQBCustomerModal').modal('show');
        },
        selectFromExistingQBCustomersModalClose(){
            this.selectedQuickBookCustomer = null;
            $('#selectFromExistingQBCustomerModal').modal('hide');
            this.selectOptionsForQuickBook();
        },
        selectQBCustomer(){
            if(!this.selectedQuickBookCustomer){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select a customer from drop down'
                });
                return false;
            }else{
                let payload = {'QBCustomer': this.selectedQuickBookCustomer, 'company': this.company, 'contact': this.contact};
                axios.post(route('quick-book.select-quick-book-customer'), payload).then(response => {
                    if(response.data.status == 'success'){
                        $('#selectFromExistingQBCustomerModal').modal('hide');
                        this.selectedQuickBookCustomer = null;
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.fetchInvoices();
                    }else{
                        this.getToast().fire({
                            type: 'error',
                            title: response.data.message
                        });
                    }
                });
            }
        },
        selectCompanyContactForQBModal(){

            if(this.contacts.length == 0){
                this.getToast().fire({
                    type: 'error',
                    title: 'No contacts added to this company'
                });

                return false;
            }
            this.selectedCompanyContactForQB = null;
            this.selectOptionsForQuickBookClose();
            $('#selectCompanyContactForQBModal').modal('show');
        },
        selectCompanyContactForQBModalClose(){
            this.selectedCompanyContactForQB = null;
            $('#selectCompanyContactForQBModal').modal('hide');
            this.selectOptionsForQuickBook();
        },
        createCustomerToQB(){
            let payload = {'contact': this.contact, 'company': this.company };
            axios.post(route('quick-book.create-quick-book-customer'), payload).then(response => {
                if(response.data.status == 'success'){
                    $('#optionsForQuickBookModal').modal('hide');
                    this.selectedCompanyContactForQB = null;
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.fetchInvoices();
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });
        },
        pushContactToSageIntacct() {
            let self = this;
            self.pushToFoundationLoading = true;
            let payload = {
                'contact': self.contact,
                'company': self.company
            };
            axios.post(route('api.contact.sage-intacct.push-residential-contact'), payload).then((result) => {
                self.pushToFoundationLoading = false;
                if (result.data.sageInatcctCustomerNo) {
                    self.contact.sage_intacct_customer_no = result.data.sageInatcctCustomerNo;
                }
                self.getToast().fire({
                    type:  result.data.sageInatcctCustomerNo ? 'success' : 'error',
                    title: result.data.message,
                });
            }).catch(() => {
                self.pushToFoundationLoading = false;
                self.getToast().fire({
                    type:  'error',
                    title: 'Create on Sage Intact Failed.'
                });
            });
        },

        initAutocomplete() {
            let input = document.getElementById('searchTextField');
            autocomplete = new google.maps.places.Autocomplete(input, {
                componentRestrictions: {
                    country: ['us','ca']
                }
            });
            google.maps.event.addListener(autocomplete, 'place_changed', this.getAddressComponents);
        },
        getAddressComponents() {
            let placeResultData = autocomplete.getPlace();
            this.form.lat = placeResultData.geometry.location.lat();
            this.form.lng = placeResultData.geometry.location.lng();
            this.form.zip = '';
            this.form.city = '';
            this.form.state = '';
            placeResultData.address_components.map(res=>{
                if(res.types[0]==='postal_code'){
                    this.form.zip = res.short_name;
                }
                if(res.types[0]==='locality'){
                    this.form.city = res.short_name;
                }
                if(res.types[0]==='administrative_area_level_1'){
                    this.form.state = res.short_name;
                }
            });
            this.form.address = placeResultData.name;
        },

        spectrumCustomerCodeChanged(data){
            this.$refs.ContactSpectrumComponent.pushOrUpdateCustomerToSpectrum(data.customerCode);
        }
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.tab-btn {
    padding: 6px 10px;
    /*background: #14b1af;*/
    cursor: pointer;
    margin-bottom: 1rem;
    outline: none;
    color: #3d4852;
    height: 41px;
    width: 110px;
}

.contactTabs {
    /*background: #14b1af;*/
    min-height: 41px;
    height: fit-content;
}

.active {
    border-bottom: 3px solid green;
    background: #fcfcf;
}

.tab {
    padding: 0px;
}
button.material-icons.followpUpCss {
    margin-left: -17px;
    font-size: 15px;
}
.circle{
    height: 100px;
    width: 100px;
    margin: 0 auto;
    margin-bottom: 10px;
    border-radius: 50%;
}
.select-height {
    height: 33px !important;
}
.proposal-overlay{
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    cursor: pointer;
    background: #ffffffd9;
}
.loading-custom{
    position: relative;
    height: 100vh;
    top: 40vh;
    text-align: center;
    font-size: 40px;
}
.tab-body-custom-class{
    padding-bottom: 15px !important;
}
.text-green-foundation {
    color: #3eb784;
    font-size: 14px;
}
/*@media only screen and (max-width: 1024px) {*/
/*    .syncFoundationDiv {*/
/*        padding-right: 70px;*/
/*    }*/
/*}*/
/*@media only screen and (max-width: 768px) {*/
/*    .syncFoundationDiv {*/
/*        padding-right: 50px;*/
/*    }*/
/*}*/
/*@media only screen and (max-width: 425px) {*/
/*    .syncFoundationDiv {*/
/*        padding-right: 23px;*/
/*    }*/
/*}*/
/*@media only screen and (max-width: 320px) {*/
/*    .syncFoundationDiv {*/
/*        padding-right: 10px;*/
/*    }*/
/*}*/
/*@media only screen and (min-width: 1400px) {*/
/*    .syncFoundationDiv {*/
/*        padding-right: 100px;*/
/*    }*/
/*}*/



.model_loader{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        display: none;
        background: rgb(0 0 0 / 57%);
    }
.model_loader .model_spinner{
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
